const FortaClass=[
    {
        class: "A",
        description: "Indispensable drug, clear-cut benefit in terms of efficacy/safety ratio proven in elderly patients for a given indication",
    },
    {
        class: "B",
        description: "Drugs with proven or obvious efficacy in the elderly, but limited extent of effect and/or safety concerns",
    },
    {
        class: "C",
        description: "Drugs with questionable efficacy/safety profiles in the elderly which should be avoided or omitted in the presence of too many drugs, absence of benefits or emerging side effects; explore alternatives",
    },
    {
        class: "D",
        description: "Avoid if at all possible in the elderly, omit first and use alternative substances",
    },
]

export default FortaClass;